import React from 'react'
import { Text } from 'components/base'

export function SendActivityToIntegrationSection({
  applicationName,
  children,
}) {
  return (
    <React.Fragment>
      <Text.Section className="margin-bottom-normal">
        Send activity to {applicationName}
      </Text.Section>
      {children}
    </React.Fragment>
  )
}
